import { render, staticRenderFns } from "./PlanfixGamesList.vue?vue&type=template&id=27a181ef&"
import script from "./PlanfixGamesList.vue?vue&type=script&lang=js&"
export * from "./PlanfixGamesList.vue?vue&type=script&lang=js&"
import style0 from "./PlanfixGamesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports